import type { VentaAutorizacionPayload } from '../shared/types/venta-form';
import { $, escapeHtml } from '../shared/utils/dom';
import { fmtFechaDia, fmtKg } from '../shared/utils/format';

function confirmRow(label: string, value: string): string {
  return (
    '<div class="confirm-row"><span class="confirm-row__label">' +
    escapeHtml(label) +
    '</span><span class="confirm-row__value">' +
    escapeHtml(value) +
    '</span></div>'
  );
}

export function renderConfirmSummary(
  data: VentaAutorizacionPayload,
  accountId: string,
  accountLabel: string,
  options?: { manualCampaign?: boolean }
): void {
  const cuenta = accountLabel ? '(' + accountId + ') ' + accountLabel : accountId;
  const precioTxt =
    data.precioTipo === 'base' ? '$' + data.precio + ' / qq' : 'Precio mercado';
  const vtoTxt = data.fechaVencimiento ? fmtFechaDia(data.fechaVencimiento) : '—';
  const cosechasHtml = (data.cosechas || [])
    .map(
      (c) =>
        '<span>' +
        escapeHtml(c.nombre) +
        ' · ' +
        escapeHtml(fmtKg(c.kilos)) +
        ' kg</span>'
    )
    .join('');

  const el = $('confirm-summary');
  if (!el) return;

  el.innerHTML =
    confirmRow('Cuenta', cuenta) +
    confirmRow('Emisión', fmtFechaDia(data.fechaEmision)) +
    confirmRow(
      'Grano',
      data.grano + (options?.manualCampaign ? ' · Seleccionado manualmente' : '')
    ) +
    confirmRow('Kilos', fmtKg(data.kilos) + ' kg') +
    confirmRow('Precio', precioTxt) +
    confirmRow('Vencimiento', vtoTxt) +
    (cosechasHtml
      ? '<div class="confirm-row" style="flex-direction:column;align-items:stretch"><span class="confirm-row__label">Cosechas</span><div class="confirm-cosechas">' +
        cosechasHtml +
        '</div></div>'
      : '') +
    (data.observacion ? confirmRow('Observación', data.observacion) : '');
}
